module.exports = __webpack_public_path__ + "img/page.7de59674.png";